module.exports = __webpack_public_path__ + "static/media/new-letter-bg.40d48a05.jpg";